import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import FormGuarantee from '../../../../view/FormGuarantee';
import Data from '../../../../data/StateDeedOfSaleOfMotorVehicle.json';
import converter from 'number-to-words';
import Loading from '../../../../view/Loading';
import PaperSignatoriesForPdf from '../../../../model/PaperSignatoriesForPdf';
import PaperSignatoriesAcknowledgementForPdf from '../../../../model/PaperSignatoriesAcknowledgementForPdf';
import {Noun, SubjectVerb} from '../../../../model/Helper';
import RequiredData from '../../../../model/RequiredData';
import PaperPartyPdf from '../../../../model/PaperPartyPdf';
import FormFinal from '../../../../view/FormFinal';
import Meta from '../../../../model/Meta';

class DeedOfSaleOfMotorVehicleStep6 extends Component {

    constructor(props){
        super(props);
        this.state = Data;
    }

    componentWillMount() {
        if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
                    RequiredData.motorVehicle(this.state, this.state.formPath+"/1");
					RequiredData.seller(this.state, this.state.formPath+"/2");
                    RequiredData.buyer(this.state, this.state.formPath+"/3");
                    RequiredData.price(this.state, this.state.formPath+"/4");
                    
				    localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}
    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
    }

    handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;

	    this.setState({
			destinationEmail: value
		}, ()=>{
			let regex =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if(regex.test(value)) {
				$(".download").addClass("btn-success").prop("disabled", false);
				$(".form-text").addClass("d-none");
			} else {
				$(".download").removeClass("btn-success").prop("disabled", true);
				$(".form-text").removeClass("d-none");
			}
		});
	}

    render() {

        // Data
        let p = this.state.details.property;
        let s = this.state.details.seller;
        let b = this.state.details.buyer;

        let nounSeller = Noun(s, "seller");
        let nounBuyer = Noun(b, "buyer");

        let blankLine = "____________________";

        // Natural person variables
        let sellerName = [], 
            sellerSpouseName = [],
            sellerNationality = [],
            sellerAddress = [],
            sellerRepresentativeName = [],
            sellerRepresentativeNationality = [],
            sellerRepresentativeAddress = [],
            sellerTin = [];
        // Corporation variables
        let sellerCorporationName = [],
            sellerCorporationPrincipalPlaceOfBusiness = [],
            sellerCorporationRepresentativeName = [],
            sellerCorporationRepresentativePosition = [],
            sellerCorporationTin = [];
        this.state.details.seller.forEach((seller, i)=>{
            sellerName[i] = (seller.sellerFname || seller.sellerMname || seller.sellerLname) ? 
                                    (seller.sellerFname+(seller.sellerMname?` ${seller.sellerMname}`:"")+(seller.sellerLname?` ${seller.sellerLname}`:"")+(seller.sellerSuffix?` ${seller.sellerSuffix}`:"")): 
                                    blankLine;
            sellerSpouseName[i] = (seller.sellerSpouseFname || seller.sellerSpouseMname || seller.sellerSpouseLname) ? 
            (seller.sellerSpouseFname+(seller.sellerSpouseMname?` ${seller.sellerSpouseMname}`:"")+(seller.sellerSpouseLname?` ${seller.sellerSpouseLname}`:"")+(seller.sellerSpouseSuffix?` ${seller.sellerSpouseSuffix}`:"")): 
            blankLine;
            sellerNationality[i] = seller.sellerNationality ? seller.sellerNationality : blankLine;
            sellerAddress[i] = seller.sellerAddress ? seller.sellerAddress :  blankLine;
            
            sellerRepresentativeName[i] = (seller.sellerRepresentativeFname || seller.sellerRepresentativeMname || seller.sellerRepresentativeLname) ? 
                                    (seller.sellerRepresentativeFname+(seller.sellerRepresentativeMname?` ${seller.sellerRepresentativeMname}`:"")+(seller.sellerRepresentativeLname?` ${seller.sellerRepresentativeLname}`:"")+(seller.sellerRepresentativeSuffix?` ${seller.sellerRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerRepresentativeNationality[i] = seller.sellerRepresentativeNationality ? seller.sellerRepresentativeNationality : blankLine;
            sellerRepresentativeAddress[i] = seller.sellerRepresentativeAddress ? seller.sellerRepresentativeAddress :  blankLine;
            sellerTin[i] = seller.sellerTin ? seller.sellerTin : "";

            sellerCorporationName[i] = seller.sellerCorporationName ? seller.sellerCorporationName : blankLine;
            sellerCorporationPrincipalPlaceOfBusiness[i] = seller.sellerCorporationPrincipalPlaceOfBusiness ? seller.sellerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            sellerCorporationRepresentativeName[i] = (seller.sellerCorporationRepresentativeFname || seller.sellerCorporationRepresentativeMname || seller.sellerCorporationRepresentativeLname) ? 
                                    (seller.sellerCorporationRepresentativeFname+(seller.sellerCorporationRepresentativeMname?` ${seller.sellerCorporationRepresentativeMname}`:"")+(seller.sellerCorporationRepresentativeLname?` ${seller.sellerCorporationRepresentativeLname}`:"")+(seller.sellerCorporationRepresentativeSuffix?` ${seller.sellerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerCorporationTin[i] = seller.sellerCorporationTin ? seller.sellerCorporationTin : "";
            sellerCorporationRepresentativePosition[i] = seller.sellerCorporationRepresentativePosition ? seller.sellerCorporationRepresentativePosition : blankLine;
            
        });

        // Natural person variables
        let buyerName = [], 
            buyerSpouseName = [],
            buyerNationality = [],
            buyerAddress = [],
            buyerRepresentativeName = [],
            buyerRepresentativeNationality = [],
            buyerRepresentativeAddress = [],
            buyerTin = [];
        // Corporation variables
        let buyerCorporationName = [],
            buyerCorporationPrincipalPlaceOfBusiness = [],
            buyerCorporationRepresentativeName = [],
            buyerCorporationRepresentativePosition = []
        
        this.state.details.buyer.forEach((buyer, i)=>{
            buyerName[i] = (buyer.buyerFname || buyer.buyerMname || buyer.buyerLname) ? 
                                    (buyer.buyerFname+(buyer.buyerMname?` ${buyer.buyerMname}`:"")+(buyer.buyerLname?` ${buyer.buyerLname}`:"")+(buyer.buyerSuffix?` ${buyer.buyerSuffix}`:"")): 
                                    blankLine;
            buyerSpouseName[i] = (buyer.buyerSpouseFname || buyer.buyerSpouseMname || buyer.buyerSpouseLname) ? 
            (buyer.buyerSpouseFname+(buyer.buyerSpouseMname?` ${buyer.buyerSpouseMname}`:"")+(buyer.buyerSpouseLname?` ${buyer.buyerSpouseLname}`:"")+(buyer.buyerSpouseSuffix?` ${buyer.buyerSpouseSuffix}`:"")): 
            blankLine;
            buyerNationality[i] = buyer.buyerNationality ? buyer.buyerNationality : blankLine;
            buyerAddress[i] = buyer.buyerAddress ? buyer.buyerAddress :  blankLine;
            
            buyerRepresentativeName[i] = (buyer.buyerRepresentativeFname || buyer.buyerRepresentativeMname || buyer.buyerRepresentativeLname) ? 
                                    (buyer.buyerRepresentativeFname+(buyer.buyerRepresentativeMname?` ${buyer.buyerRepresentativeMname}`:"")+(buyer.buyerRepresentativeLname?` ${buyer.buyerRepresentativeLname}`:"")+(buyer.buyerRepresentativeSuffix?` ${buyer.buyerRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerRepresentativeNationality[i] = buyer.buyerRepresentativeNationality ? buyer.buyerRepresentativeNationality : blankLine;
            buyerRepresentativeAddress[i] = buyer.buyerRepresentativeAddress ? buyer.buyerRepresentativeAddress :  blankLine;

            buyerCorporationName[i] = buyer.buyerCorporationName ? buyer.buyerCorporationName : blankLine;
            buyerCorporationPrincipalPlaceOfBusiness[i] = buyer.buyerCorporationPrincipalPlaceOfBusiness ? buyer.buyerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            buyerCorporationRepresentativeName[i] = (buyer.buyerCorporationRepresentativeFname || buyer.buyerCorporationRepresentativeMname || buyer.buyerCorporationRepresentativeLname) ? 
                                    (buyer.buyerCorporationRepresentativeFname+(buyer.buyerCorporationRepresentativeMname?` ${buyer.buyerCorporationRepresentativeMname}`:"")+(buyer.buyerCorporationRepresentativeLname?` ${buyer.buyerCorporationRepresentativeLname}`:"")+(buyer.buyerCorporationRepresentativeSuffix?` ${buyer.buyerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerTin[i] = buyer.buyerTin ? buyer.buyerTin : "";
            buyerCorporationRepresentativePosition[i] = buyer.buyerCorporationRepresentativePosition ? buyer.buyerCorporationRepresentativePosition : blankLine; 

        });

        let priceNumber = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                                Number(p.price).toLocaleString() :
                                blankLine;		
        let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                            converter.toWords(p.price) : 
                            blankLine;

        let contract_html = `
        <style type="text/css">
            @import url("./css/styles.css");
            @import url("./css/styles-custom.css");
        </style>

        <div class="pdf">

            <div class="paper">
                
                <div class="paper-title text-center">
                    Deed of Sale of Motor Vehicle
                </div>

                <div class="text-uppercase py-3">
                    KNOW ALL MEN BY THESE PRESENTS:
                </div>

                <div>
                    <p>
                        This Deed of Sale of Motor Vehicle (hereinafter "Deed") is made and entered into by and between:
                    </p>
                </div>

                <div class="my-3">
                    ${PaperPartyPdf(s, "seller")}
                </div>

                <div class="paper-narrow my-3 text-center">
                    <div class="my-3">- and -</div>
                </div>

                <div class="my-3">
                    ${PaperPartyPdf(b, "buyer")}
                </div>

                <div class="paper-narrow my-3 text-center">
                    <div class="my-3"><strong>WITNESSETH</strong>: That-</div>
                </div>

                <div>
                    <p>
                        WHEREAS, for and in consideration of the sum of <span class="dynamic-data text-uppercase">${priceText}</span> PESOS (P<span class="dynamic-data">${priceNumber}</span>) Philippine Currency, receipt of which is hereby acknowledged, the <span class="text-uppercase">${nounSeller}</span> hereby SELL, TRANSFER and CONVEY unto the <span class="text-uppercase">${nounBuyer}</span> its heirs and assigns, on an “as is where is” basis, free and clear of all liens, encumbrances, or claims whatsoever, a certain motor vehicle more particularly described as follows:   
                    </p>
                    <table class="table table-bordered table-even">
                        <tbody>
                            <tr>
                                <td>Make:<br /><span class="dynamic-data font-weight-bold text-uppercase">${p.make}</span></td>
                                <td>MV File No.<br /><span class="dynamic-data font-weight-bold text-uppercase">${p.mvFileNo}</span></td>
                            </tr>
                            <tr>
                                <td>Series:<br /><span class="dynamic-data font-weight-bold text-uppercase">${p.series}</span></td>
                                <td>Plate No. / Conduction Sticker No.<br /><span class="dynamic-data font-weight-bold text-uppercase">${p.plateConductionNo}</span></td>
                            </tr>
                            <tr>
                                <td>Body Type:<br /><span class="dynamic-data font-weight-bold text-uppercase">${p.bodyType}</span></td>
                                <td>Engine No.<br /><span class="dynamic-data font-weight-bold text-uppercase">${p.engineNo}</span></td>
                            </tr>
                            <tr>
                                <td>Year Model:<br /><span class="dynamic-data font-weight-bold text-uppercase">${p.yearModel}</span></td>
                                <td>Chassis No.<br /><span class="dynamic-data font-weight-bold text-uppercase">${p.chassisNo}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div>
                    <p>
                        WHEREAS, the <span class="text-uppercase">${nounSeller}</span> ${SubjectVerb(nounSeller, "is")} the absolute and registered owner of the subject motor vehicle covered by Certificate of Registration No. <span class="dynamic-data text-uppercase">${p.certificateOfRegistrationNo}</span> issued by the Land Transportation Office.
                    </p>
                </div>
                
                <br />
                <br />

                <div>
                    <p>
                        IN WITNESS WHEREOF, the parties have hereunto set their hands this _______________ in _______________. 
                    </p>
                </div>

                <br />

                <div>
                    ${PaperSignatoriesForPdf(s, b)}
                </div>

                <br />
                <br />
                <br />

                <div class="mt-5">
                    <div>
                        Signed in the presence of:
                    </div>
                    <table class="table-even mt-5">
                        <tr>
                            <td class="text-center">
                                <div class="blank-line-long "></div>
                            </td>
                            <td class="text-center">
                                <div class="blank-line-long "></div>
                            </td>
                        </tr>
                    </table>
                </div>  

            </div>

            <div class="paper" style="page-break-before: always;">
                
                <table class="table-even">
                    <tr>
                        <td>
                            <table>
                                <tr><td><div class="pr-25">REPUBLIC OF THE PHILIPPINES )</div></td></tr>
                                <tr><td><div class="text-right">)S.S.</div></td></tr>
                            </table>
                        </td>
                        <td>
                        </td>
                    </tr>
                </table>

                <div class="paper-title text-center">
                    Acknowledgement
                </div>

                <div>
                    <p>
                        BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                    </p>
                </div>

                ${PaperSignatoriesAcknowledgementForPdf(s, b)}

                <div>
                    <p>
                        Known to me and to me known to be the same persons who executed the foregoing Deed of Sale of Motor Vehicle consisting of [PAGES] pages, including this page where the acknowledgement is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                    </p>
                    <p>
                        WITNESS MY HAND AND SEAL in the place and on the date first above written.
                    </p>
                </div>

                <br />
                <br />
                <div class="docno">
                    Doc No. ________; <br />
                    Page No. _______; <br />
                    Book No. _______; <br />
                    Series of 20 ___. <br />
                </div>	

            </div>

        </div>`;
        
        let fn = "deed_of_sale_of_motor_vehicle_contracts_ph_"+Date.now();
        let dn = this.state.formName;

        const meta = {
            title: "Your free custom Deed of sale of Motor Vehicle is ready for download",
            description: "Download your free custom Deed of Sala of Motor Vehicle - Create your custom Deed of sale of motor vehicle"
        }

        return(
            <div className="page page-inner page-contract">
                <Meta {...meta}/>
                <Loading />
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
                                <ContractCreate />
                                <ProgressBar percentage={Math.floor((5/5)*100)} />

                                {/* Final step starts here */}
                                <div className="my-5 text-center">
                                    <FormFinal 
                                        contract_html={contract_html} 
                                        fn={fn} 
                                        dn={dn} 
                                        formPath={this.state.formPath}
                                        details={this.state.details} />
                                </div>

								<FormGuarantee />

								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 5/5</p>
									<Link to={this.state.formPath+"/4"} className="btn btn-lightblue mr-2">Go Back and Edit</Link>
								</div>

                            </div>
                            <div className="col-12 col-md-7 right-preview">
                                <Preview {...this.state} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DeedOfSaleOfMotorVehicleStep6;


// WEBPACK FOOTER //
// ./src/pages/contracts/business/deed-of-sale-of-motor-vehicle/DeedOfSaleOfMotorVehicleStep5.js